export const QUERY = {
  TOKEN: 'token',
};
